import type { Attachment } from '../../models/attachment';

/**
 * Categorizes attachments by type - Open-Closed Principle: Easy to extend for new types
 */
export const categorizeAttachments = (attachments: Attachment[]) => {
  const imageFn = (f: Attachment) => f.mimeType!.startsWith('image/') || f.mimeType!.startsWith('video/');
  const audioFn = (f: Attachment) => f.mimeType!.startsWith('audio/');

  return {
    medias: attachments.filter(imageFn),
    audios: attachments.filter(audioFn),
    files: attachments.filter((f) => !imageFn(f) && !audioFn(f))
  };
};

/**
 * Liskov Substitution Principle: Functions work with base Attachment class
 * Can be extended with new attachment subclasses without breaking existing code
 */
export const isAttachmentOfType = (attachment: Attachment, type: string): boolean => {
  return attachment.mimeType?.startsWith(type) ?? false;
};
